import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

import { reactive, watchEffect, computed } from 'vue';
	import { Form, Field, ErrorMessage } from 'vee-validate';
	import { Schema } from 'yup';
	import { ServiceType } from '@/models/loans';
	import Popover from '@/components/shared/Popover.vue';

	interface FormField {
		name: string;
		label: string;
		type: string;
		value: any;
		width: string;
		options?: ServiceType[];
		tooltip?: string;
	}

	
export default /*@__PURE__*/_defineComponent({
  __name: 'PostDisbursementChangeForm',
  props: {
    onSubmit: { type: Function },
    onClose: { type: Function },
    fields: {},
    validationSchema: {},
    isSubmitting: { type: Boolean }
  },
  setup(__props: any) {

	const props = __props;

	const formData = reactive<Record<string, any>>({});

	const isFormValid = computed(() => {
		return (errors: Partial<Record<string, string | undefined>>) => errors && Object.keys(errors).length === 0;
	});

	async function onSubmit() {
		if (props.onSubmit) {
			await props.onSubmit({ ...formData });
		}
	}

	function clearFormData() {
		props.fields.forEach((field) => {
			formData[field.name] = field.value;
		});
	}

	watchEffect(() => {
		props.fields.forEach((field) => {
			formData[field.name] = field.value;
		});
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("h3", null, "Post-Disbursement Change")
      ], -1)),
      _createVNode(_unref(Form), {
        "validation-schema": __props.validationSchema,
        class: "form-container",
        onSubmit: onSubmit
      }, {
        default: _withCtx(({ errors }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.name,
              class: _normalizeClass(['form-input', field.width])
            }, [
              _createElementVNode("label", {
                for: field.name
              }, [
                _createTextVNode(_toDisplayString(field.label) + " ", 1),
                (field.tooltip)
                  ? (_openBlock(), _createBlock(Popover, {
                      key: 0,
                      text: field.tooltip
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3),
              (field.type === 'select')
                ? (_openBlock(), _createBlock(_unref(Field), {
                    key: 0,
                    as: "select",
                    id: field.name,
                    name: field.name,
                    modelValue: formData[field.name],
                    "onUpdate:modelValue": ($event: any) => ((formData[field.name]) = $event),
                    disabled: __props.isSubmitting
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("option", null, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          value: option.id
                        }, _toDisplayString(option.name), 9, _hoisted_4))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["id", "name", "modelValue", "onUpdate:modelValue", "disabled"]))
                : (_openBlock(), _createBlock(_unref(Field), {
                    key: 1,
                    id: field.name,
                    name: field.name,
                    type: field.type,
                    modelValue: formData[field.name],
                    "onUpdate:modelValue": ($event: any) => ((formData[field.name]) = $event),
                    disabled: __props.isSubmitting
                  }, null, 8, ["id", "name", "type", "modelValue", "onUpdate:modelValue", "disabled"])),
              _createVNode(_unref(ErrorMessage), {
                name: field.name,
                class: "error"
              }, null, 8, ["name"])
            ], 2))
          }), 128)),
          _createElementVNode("button", {
            class: "submit-button col-6",
            type: "submit",
            disabled: !isFormValid.value(errors) || __props.isSubmitting
          }, " Submit ", 8, _hoisted_5),
          _createElementVNode("button", {
            class: "secondary col-3",
            type: "button",
            disabled: __props.isSubmitting,
            onClick: _withModifiers(clearFormData, ["prevent"])
          }, " Clear ", 8, _hoisted_6),
          _createElementVNode("button", {
            class: "secondary col-3",
            type: "button",
            disabled: __props.isSubmitting,
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (__props.onClose && __props.onClose(...args)), ["prevent"]))
          }, " Close ", 8, _hoisted_7)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}
}

})